export default "/images/framework/HamburgerIconNoShadow.16453d6d.svg?16453d6d";